<template>
    <div id="eval_new_step2" class="flex">

        <titlePage>
            <template slot="titleBody">
                <h1 class="title is-size-1 has-text-weight-light stepTitle page-title">{{ currentEval.candidate_first_name }} {{ currentEval.candidate_last_name }}</h1>
                <h2 class="associated_ref_name">{{ $t('modules.evaluations.formStep2.email') }} : <span>{{ currentEval.candidate_email }}</span></h2>
            </template>
        </titlePage>

        <div class="subsection_container hero flex">

            <div class="hero-body flex_content">
                <div class="container  mini-container has-text-centered">

                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">
                        {{ $t('modules.evaluations.formStep2.associatedRef') }}
                    </h2>

                    <div class="form_material_container">

                        <RefSelectByCat
                            v-if="usedRef == 'saven'"
                            :isCustom="false"
                            :selectedCatId="selectedCatId"
                            :selectedRefId="selectedRefId"
                            @SelectChanged="setRefValues" />

                        <btn-circle-icon
                            :class="{disabled: !isFormValid}"
                            class="large is-cursor"
                            icon="icon-arrow-right"
                            @click.native="nextStep" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'FormEvalStep2',
    components: {
        TitlePage
    },
    mounted(){
        this.usedRef = 'saven'
    },
    data(){
        return {
            usedRef: 'saven',
            userRole: JSON.parse(localStorage.getItem('account')).licence.account_type,
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        isFormValid(){
            return (this.associatedRef && this.associatedRef.id) ? true : false
        },
        associatedCat(){
            return this.$store.state.EvalStore.associatedCat
        },
        associatedRef(){
            return this.$store.state.EvalStore.associatedRef
        },
        selectedRefId(){
            return (this.associatedRef) ? this.associatedRef.id : null
        },
        selectedCatId(){
            return (this.associatedCat) ? this.associatedCat.id : null
        }
    },
    methods: {
        nextStep(){
            if(this.isFormValid){
                this.$store.commit('EvalStore/changeCurrentStep', { index: 2 })
            }
        },
        setRefValues(selectedCatId, selectedRefId, selectedRef, selectedCat){
            const associatedData = {
                associatedRef: selectedRef,
                associatedCat: selectedCat,
                associatedRefType: this.usedRef
            }
            this.$store.commit('EvalStore/setAssociatedObjects', associatedData)
            this.$store.commit('EvalStore/updateFormValidity', { index: 1, validity: this.isFormValid } )
        }
    },
    watch: {
        usedRef: function(newVal, oldVal){
            const associatedData = {
                associatedRef: {},
                associatedCat: {},
                associatedRefType: this.usedRef
            }
            this.$store.commit('EvalStore/setAssociatedObjects', associatedData)
        }
    }
}
</script>

<style lang="scss">
#eval_new_step2{
    background: $white;
    display: flex;
    flex-direction: column;
    .subsection_container{
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.form_material_container{
    margin: 0 auto 50px;
    .select{
        width: 100%;
        select{
            width: 100%;
        }
    }
}
.choose_ref{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    .radio_button{
        input{
            opacity: 0;
            height: 0;
            width: 0;
        }
        label{
            padding: 20px;
            // background: $grey-lighter;
            text-transform: uppercase;
            border-bottom: 3px solid $grey-lighter;
            font-weight: 500;
            color: $grey-light;
            transition: .3s all;
        }
        input:checked + label{
            border-bottom-color: $info;
            color: $info;
        }
    }
}
</style>